<div class="default-dialog">
    <div class="dialog-header">
        <h3>{{ 'CUSTOMER_SEARCH_DIALOG.TITLE' | translate }}</h3>
        <div class="header-close">
            <button mat-icon-button color="primary" mat-dialog-close>
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-dialog-content>
        <div class="content-search">
            <div class="search-search">
                <div class="default-form-field">
                    <mat-form-field appearance="outline">
                        <input
                            data-at-search-input
                            matInput
                            [placeholder]="'CONFIGURATION.CUSTOMER_SEARCH.SEARCH_BY_KEYWORD_PLACEHOLDER' | translate"
                            [(ngModel)]="searchCustomerValue"
                            (keyup.enter)="onCustomerSearch()"
                            cdkFocusInitial
                        />
                        <button mat-icon-button type="button" matSuffix (click)="onCustomerSearch()">
                            <mat-icon>search</mat-icon>
                        </button>
                    </mat-form-field>
                </div>
            </div>
            <div class="search-loader" *ngIf="isLoading">
                <app-loader
                    [message]="'CONFIGURATION.CUSTOMER_SEARCH.LOADER_TEXT' | translate"
                    [isDialog]="true"
                ></app-loader>
            </div>
            <div class="search-result" *ngIf="customerSearchResult">
                <div class="result-header">
                    <h4>{{ 'COMMON.SEARCH_RESULTS' | translate }}:</h4>
                </div>
                <div class="result-items">
                    <ng-container *ngIf="customerSearchResult">
                        <div class="item" *ngFor="let cust of customerSearchResult">
                            <div class="item-details">
                                <div class="details-number">
                                    {{ cust.number }}
                                </div>
                                <div class="details-name">
                                    {{ cust.name }}
                                </div>
                                <div class="details-address">
                                    {{ cust.streetFormatted }} <br />
                                    {{ cust.city }}
                                </div>
                            </div>
                            <button mat-stroked-button color="primary" (click)="selectCustomer(cust)">
                                {{ 'CONFIGURATION.CUSTOMER_SEARCH.BTN.SELECT_CUSTOMER' | translate }}
                            </button>
                        </div>
                    </ng-container>
                </div>
                <div
                    *ngIf="customerSearchResult?.length === 0 && searchCustomerValue"
                    fxLayout="row"
                    fxLayoutAlign="center center"
                >
                    <p data-at-no-results>{{ 'COMMON.NO_RESULTS_FOR' | translate }} "{{ searchCustomerValue }}"</p>
                </div>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button
            mat-button
            color="primary"
            *ngIf="searchCustomerValue && customerSearchResult"
            (click)="searchCustomerValue = ''"
            class="reset"
        >
            {{ 'COMMON.DIALOG.CLEAR' | translate }}
        </button>
        <button mat-stroked-button color="primary" mat-dialog-close>
            {{ 'COMMON.DIALOG.CANCEL' | translate }}
        </button>
        <button mat-flat-button color="primary" [disabled]="isLoading" (click)="onCustomerSearch()">
            {{ 'COMMON.SEARCH' | translate }}
        </button>
    </mat-dialog-actions>
</div>
